/*
  Subscription options facade UI with appstle
  implemented: layout\theme.liquid
  note: this was jquery code from gempages templates
*/

document.addEventListener("DOMContentLoaded", function () {
  console.log('loaded shugert')

  const PLANS = {
  'one-time': 'Single Unit',
  'monthly-sub': 'Monthly Subscription',
  'sub': 'Subscribe & Save'
  }

  const opt_1 = document.querySelector('.purchase-ooption.sub')
  const opt_2 = document.querySelector('.purchase-ooption.monthly-sub')
  const opt_3 = document.querySelector('.purchase-ooption.one-time')       
  const current_plan = document.querySelector('.purchase-ooption.active')  
  const atc_button = document.querySelector('.AddToCartText')      

  if(!opt_1 || !opt_2 || !opt_3 || !current_plan || !atc_button){
    return console.log("cant find DOM elements")
  }

  // first load
  if(current_plan.classList.length === 0){
    return console.log('No custom class with plan')
  }

  const [plan_classlist] = [...current_plan.classList].filter(class_attr => class_attr === 'sub' || class_attr === 'monthly-sub' || class_attr === 'one-time') 

  whenAvailable("#SingleOptionSelector-product-0", function(el) {
    console.log('current_plan', plan_classlist)
    console.log("App fully loaded", el)
    setAppstleDropdown(PLANS[plan_classlist])
    
    const plan_price = getPlanPrice()
    updateAddToCartText(plan_price)

  }, 0);


  // onchange
  opt_1.addEventListener('click', () => selectPlan(opt_1, PLANS['sub']))
  opt_2.addEventListener('click', () => selectPlan(opt_2, PLANS['monthly-sub']))
  opt_3.addEventListener('click', () => selectPlan(opt_3, PLANS['one-time']))

  function selectPlan(el, plan_type){

    removePreviosActive()

    el.classList.add('active')

    setAppstleDropdown(plan_type)

    const plan_price = getPlanPrice()
    updateAddToCartText(plan_price)
  
  }


  // utils
  function removePreviosActive(){
    const actived = document.querySelectorAll('.purchase-ooption.active')
    actived.forEach((active) => active.classList.remove('active'))
  }

  function setAppstleDropdown(plan){
    const master = document.querySelector('#SingleOptionSelector-product-0')
    master.value = plan
    master.dispatchEvent(new Event('change'));
  }

  function updateAddToCartText(plan_price){
    const text = atc_button.innerText
    atc_button.innerText = `${text} - ${plan_price}`
  }

  function getPlanPrice(){
    const plan_price = document.querySelector('.gf_product-price').innerText
    console.log('plan_price', plan_price)
    return plan_price
  }

  function whenAvailable(DOM_element, callback, number_of_trys) {
    number_of_trys += 1;
    const appEl = document.querySelector(DOM_element)
    const interval = 1000; 
  
    console.log( number_of_trys)
    const int = window.setTimeout(function() {
        if (appEl) {
            callback(appEl);
            clearInterval(int)
        } else {
          number_of_trys <= 10 ? whenAvailable(DOM_element, callback, number_of_trys) : console.log("Reached limit for number_of_trys", number_of_trys);
        }
    }, interval);
  }

})
